import React, { useEffect, useState } from "react";
import { Container, Text, Title, Paper, Loader, Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useStore } from "../store";
import { getTenantProfile } from "../api";

function PaymentSuccess() {
  const { t } = useTranslation("common");
  const setTenantProfile = useStore((state) => state.setTenantProfile);
  const [isLoading, setIsLoading] = useState(true);

  function sleeper(ms) {
    return function (x) {
      return new Promise((resolve) => setTimeout(() => resolve(x), ms));
    };
  }

  useEffect(() => {
    // Wait 2s for the webhooks to update the profile, then fetch
    sleeper(2000)().then(() => {
      getTenantProfile().then((data) => {
        setTenantProfile(data);
        setIsLoading(false);
      });
    });
  }, []);

  return (
    <Container size="sm" ta="center">
      <Paper mt="xl" p="lg" withBorder>
        <Title mb="md" order={2}>
          {t("payment.success.title")}
        </Title>

        {isLoading ? (
          <>
            <Loader />
            <Text>{t("payment.success.processing")}</Text>
          </>
        ) : (
          <div>
            <Text>{t("payment.success.done")}</Text>
            <Button component="a" href="/settings/tenant" mt="lg">
              {t("payment.success.proceed")}
            </Button>
          </div>
        )}
      </Paper>
    </Container>
  );
}

export default PaymentSuccess;
